<template>
  <div>
    <div class="teacherIdentitySelectWra">
      <div class="mainWra">
        <div
          class="mainItem"
          :class="{ mainItemSelected: select.teacherIdentity === '' }"
          @click="mainAll"
        >
          全部
        </div>
        <div
          v-for="item in list"
          :key="item.value"
          class="mainItem"
          :class="{ mainItemSelected: select.teacherIdentity === item.value }"
          @click="mainClick(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="footer">
        <div class="footerBtn" @click="clearAll">重置</div>
        <div class="footerBtn" @click="sure">确定</div>
      </div>
    </div>
    <div class="overlay" @click="sure"></div>
  </div>
</template>

<script>
export default {
  name: 'teacherIdentitySelect',
  props: {
    select: {},
    type: {}
  },
  data () {
    return {
      list: [
        {
          label: '博士博士后',
          value: '博士'
        },
        {
          label: '教职导师',
          value: '教职导师'
        }
      ]
    }
  },
  mounted () {
    document
      .getElementsByTagName('body')[0]
      .style.setProperty(
        '--label-font-color',
        this.type === 'thesis' ? '#D0AF8B' : '#5BB680'
      )
  },
  methods: {
    clearAll () {
      this.select.teacherIdentity = ''
      this.sure()
    },
    mainClick (value) {
      this.select.teacherIdentity = this.select.teacherIdentity === value ? '' : value
    },
    mainAll () {
      this.select.teacherIdentity = ''
    },
    sure () {
      this.$emit('teacherIdentitySelect', '')
    }
  }
}
</script>

<style scoped lang="scss">
$labelFontColor: var(--label-font-color, #d0af8b);
@media screen and (max-width: 600px) {
  .teacherIdentitySelectWra {
    width: 100vw;
  }
  .overlay {
    width: 100vw;
  }
}
@media screen and (min-width: 601px) {
  .teacherIdentitySelectWra {
    width: 400px;
    margin: 0 auto;
  }
  .overlay {
    width: 400px;
  }
}
.teacherIdentitySelectWra {
  height: 205rem * 0.04;
  background-color: #f6f8fb;
  z-index: 3;
  position: fixed;
  top: 83rem * 0.04;
  .mainWra {
    width: 100vw;
    height: 100rem * 0.04;
    text-align: left;
    .mainItem {
      width: 100%;
      box-sizing: border-box;
      height: 40rem * 0.04;
      line-height: 40rem * 0.04;
      padding: 0 20rem * 0.04;
      font-size: 12rem * 0.04;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .mainItemSelected {
      background-color: #fff;
      color: $labelFontColor;
    }
  }
  .footer {
    display: flex;
    justify-content: space-around;
    padding: 20rem * 0.04 0 0;
    .footerBtn {
      width: 100rem * 0.04;
      height: 30rem * 0.04;
      border-radius: 8rem * 0.04;
      font-size: 12rem * 0.04;
      line-height: 30rem * 0.04;
      color: #fff;
      background-color: #656d78;
      text-align: center;
      &:last-child {
        background-color: $labelFontColor;
      }
    }
  }
}
.overlay {
  position: fixed;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2;
}
</style>
